import React, { PropsWithChildren, useRef, useEffect, useState } from 'react'

type BpAccordionProps = PropsWithChildren<{
  opened: boolean
}>

export const BpAccordion = ({ children, opened }: BpAccordionProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState('0px')

  useEffect(() => {
    if (contentRef.current) {
      if (opened) {
        setHeight(`${contentRef.current.scrollHeight}px`)
      } else {
        setHeight('0px')
      }
    }
  }, [opened])

  return (
    <div
      style={{
        overflow: 'hidden',
        transition: 'max-height 0.3s ease',
        maxHeight: height,
      }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  )
}
